import { Modal, ModalProps, ModalSizes } from "@centricsoftware/design-system";
import { CANCEL_RES, SAVE_RES } from "csi/components/constants";
import { getSlotContainerName } from "csi/page/ReactPortals/ReactPortals";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import AggregateStoreInfo from "./AggregateStoreInfo";
import { AggregateStoreInfoStore, AggregateStoreInfoStoreContext } from "./AggregateStoreInfoStore";

const modalContainerName = getSlotContainerName("body");
const modalContainer = () => document.getElementById(modalContainerName);

interface AggregateStoreDialogProps extends Pick<ModalProps, "onClose" | "title"> {
	/** save callback */
	onSave: VoidFunction;
	
	/** store for dialog */
	store: AggregateStoreInfoStore;
}

const AggregateStoreDialog: FunctionComponent<AggregateStoreDialogProps> = observer((props) => {
	const {
		onClose,
		onSave,
		store,
		title,
	} = props;
	const { disableSave } = store;

	return (
		  <Modal
			actionButtonProps={{
				childrenRes: SAVE_RES,
				disabled: disableSave,
				onClick: onSave,
			}}
			cancelButtonProps={{
				childrenRes: CANCEL_RES,
				onClick: onClose,
			}}
			// C8-76259 - https://github.com/mui/material-ui/issues/19450#issuecomment-1539832475
			container={modalContainer}
			dataCsiAutomation="AggregateStoreDialog"
			onClose={onClose}
			open
			showActionButton
			showCancelButton
			showFooter
			size={ModalSizes.ExtraLarge}
			title={title}
		  >
			<AggregateStoreInfoStoreContext.Provider value={store}>
				<AggregateStoreInfo />
			</AggregateStoreInfoStoreContext.Provider>
		</Modal>
	);
});

export default AggregateStoreDialog;